<template>
    <div class="wrapper success_base jianzhan_base">
        <div class="success_title">
            <p>
                <img src="../../assets/image/jianzhan/finish.png"  class="jz_finish_img">
            </p>
            <p class="title jz_title">恭喜你报名成功</p>
            <p class="tip jz_tip">请您注意查收短信或接听客服电话</p>
        </div>
<!--        信息卡片-->
<!--        :style="{backgroundColor: ui.bg_color === '#FFFFFF' ? '#1677FF' : ui.bg_color}"-->
        <jzcommon :title="title" :form_title="form_title" :name_placeholder="name_placeholder" :phone_placeholder="phone_placeholder"></jzcommon>
    </div>
</template>

<script>
    import _time from "@/utils/_time";
    import _object from "@/utils/_object";
    import lib_activity from "@/libs/lib_activity";
    import _wx from "@/common/_wx";
    import lib_city from "@/libs/lib_city";
    import Toast from "vant/lib/toast";
    import _regular from "@/utils/_regular";
    import lib_clue from "@/libs/lib_clue";
    import _monitor from "@/monitor/_monitor";
    import cache_url from "@/cache/cache_url";
    import lib_success from "@/libs/lib_success";
    import _geturl from "@/utils/_geturl";
    import jzpolicy from "@/components/jzpolicy";
    import _copyUrl from "@/common/_copyUrl";
    import jzcommon from "@/components/jzcommon";

    let action_form = {
        name: '', //姓名
        phone: '', //电话
        city: '', //城市
    }

    export default {
        name: "jianzhan",
        components: {jzcommon},
        data() {
            return {
                title: '', // document的title
                form_title: '帮朋友报名',
                name_placeholder: '请输入朋友姓名',
                phone_placeholder: '请输入朋友电话(已加密)'
            }
        },
        created() {

        },

        mounted() {
            // //定义需要分享的页面地址
            // this.share_url = window.location.protocol + '//' + window.location.host + '/page/success/showshare' + '?' + window.location.href.split('?')[1]
            // cache_url.set(this.share_url)
            this.title = '报名成功'
            document.title = '报名成功'
        },
    }
</script>

<style scoped lang="less">
    @import "../../assets/style/secondary/base.less";
    /*@import "../../assets/style/autoshow/form.less";*/
    /*@import "../../assets/style/secondary/jianzhan";*/
    /*// form*/
    /*@import "../../assets/style/common/successful.less"; // 成功*/
    /*/deep/ .el-divider--horizontal {*/
    /*    margin: 10px 0;*/
    /*}*/
</style>